import { Api } from "app/context/AppContext";
import UtilInterlinkApi, {
  InterfaceAuth,
  InterfaceUser,
  InterfaceClient,
  InterfacePartner,
  InterfacePartnerPartner,
  InterfacePartnerClient,
  InterfaceSystem,
  InterfaceInflux,

  ServiceAuth,
  ServiceUser,
  ServiceClient,
  ServicePartner,
  ServicePartnerPartner,
  ServicePartnerClient,
  ServiceSystem,
  ServiceInflux,

  ModelUser,
  ModelClient,
  ModelPartner,
  ModelPartnerPartner,
  ModelPartnerClient
} from '@dia-ui/util_interlink-api';

export default abstract class AbstractService {
  /**
   * api
   */
  private readonly api: UtilInterlinkApi;

  /**
   * constructor
   */
  protected constructor() {
    /**
     * api
     */
    this.api = Api;
  }

  /**
   * getApi
   */
  getApi(): UtilInterlinkApi {
    return this.api;
  }
}

/**
 * export
 */
export {
  type InterfaceAuth,
  type InterfaceUser,
  type InterfaceClient,
  type InterfacePartner,
  type InterfacePartnerPartner,
  type InterfacePartnerClient,
  type InterfaceSystem,
  type InterfaceInflux,

  ServiceAuth,
  ServiceUser,
  ServiceClient,
  ServicePartner,
  ServicePartnerPartner,
  ServicePartnerClient,
  ServiceSystem,
  ServiceInflux,

  ModelClient,
  ModelUser,
  ModelPartner,
  ModelPartnerPartner,
  ModelPartnerClient
}
